import "./App.css";
import "./components/PlatinumCard.css";
import ThreeBackground from "./components/ThreeBackground";
import PoojaCard from "./components/PoojaCard";
// For separate builds, switch this import/render manually:
// import RajniCard from "./components/RajniCard";
// import UmaCard from "./components/UmaCard";

function App() {
  return (
    <div className="App">
      <main className="card-page">
        <ThreeBackground />
        <PoojaCard />
      </main>
    </div>
  );
}

export default App;
